import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Arial",
    fontSize: 15,
    padding: VoTheme.spacing(2),
  },
  decor: {
    height: "100%",
    padding: `${VoTheme.spacing(2)} ${VoTheme.spacing(8)}`,
    width: "100%",
  },
  title: {
    color: VoTheme.palette.grey[700],
    fontSize: 24,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
  },
  subtitle: {
    color: VoTheme.palette.grey[700],
    fontSize: 20,
    fontWeight: 700,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  person: {
    color: VoTheme.palette.primary.main,
    fontSize: 24,
    fontStyle: "italic",
    fontWeight: 500,
    textAlign: "center",
  },
  text: {
    fontSize: 12,
    lineHeight: 1.2,
    textAlign: "left",
  },
  listItem: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    marginLeft: VoTheme.spacing(1),
    marginTop: VoTheme.spacing(0.5),
  },
  listItemIcon: {
    marginRight: VoTheme.spacing(1),
  },
  listItemText: {},
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: VoTheme.spacing(10),
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 250,
    paddingTop: VoTheme.spacing(0.5),
  },
  signaturePerson: {
    fontSize: 16,
    textAlign: "center",
  },
  signatureTitle: {
    fontSize: 14,
    textAlign: "center",
  },
  logoWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  logo: {
    padding: VoTheme.spacing(1),
    width: 150,
  },
  college: {},
  collegeTitle: {
    fontSize: 16,
    textAlign: "center",
  },
  date: {
    fontSize: 14,
    textAlign: "center",
  },
  footer: {},
  uid: {
    position: "absolute",
    right: VoTheme.spacing(3),
    top: 0,
  },
});
